//# sourceMappingURL=promise_.mjs.map
/// <reference types="./promise_.d.mts" />
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $dynamic from "../../../gleam_stdlib/gleam/dynamic.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import { toList, prepend as listPrepend } from "../../gleam.mjs";
import { allSettled as all_settled } from "./promise_.ffi.mjs";

export { all_settled };

export function sequence(values, run) {
  let start = $promise.resolve(toList([]));
  return $promise.map(
    $list.fold(
      values,
      start,
      (res, value) => {
        return $promise.await$(
          res,
          (res) => {
            return $promise.await$(
              run(value),
              (next) => { return $promise.resolve(listPrepend(next, res)); },
            );
          },
        );
      },
    ),
    (res) => { return $list.reverse(res); },
  );
}

export function index_sequence(values, run) {
  let start = $promise.resolve(toList([]));
  return $promise.map(
    $list.index_fold(
      values,
      start,
      (res, value, index) => {
        return $promise.await$(
          res,
          (res) => {
            return $promise.await$(
              run(value, index),
              (next) => { return $promise.resolve(listPrepend(next, res)); },
            );
          },
        );
      },
    ),
    (res) => { return $list.reverse(res); },
  );
}
